module.exports = __webpack_public_path__ + "static/media/private-groups-on.f7a669d4.png";